<section class="login-page">
  <div class="login-card">
    <div class="login-brand">
      <img *ngIf="logo" class="login-brand-logo" [src]="logo" alt="Logo do empregador">
      <span *ngIf="!logo" class="login-brand-mark">{{ iniciais }}</span>
      <div>
        <div class="login-brand-name">{{ nomeEmpresa }}</div>
        <div class="login-brand-subtitle">Portal do servidor</div>
      </div>
    </div>

    <h2>Bem-vindo!</h2>
    <p class="login-muted">Entre com CPF e senha</p>

    <form class="login-form" (ngSubmit)="entrar()">
      <input
        class="form-control login-input"
        type="text"
        name="loginCpf"
        [(ngModel)]="cpf"
        (ngModelChange)="mascararCpf()"
        placeholder="CPF"
        inputmode="numeric"
        autocomplete="username"
        required>

      <div class="input-group login-password">
        <input
          class="form-control login-input"
          [type]="senhaVisivel ? 'text' : 'password'"
          name="loginSenha"
          [(ngModel)]="senha"
          placeholder="Senha"
          autocomplete="current-password"
          required>
        <button
          type="button"
          class="login-eye"
          (click)="senhaVisivel = !senhaVisivel"
          [attr.aria-label]="senhaVisivel ? 'Ocultar senha' : 'Mostrar senha'">
          <i class="bi" [ngClass]="senhaVisivel ? 'bi-eye-slash' : 'bi-eye'"></i>
        </button>
      </div>

      <p class="login-muted" *ngIf="mensagem">{{ mensagem }}</p>
      <button class="login-submit">Entrar</button>
    </form>
  </div>
</section>
